'use client'

import { useState, useLayoutEffect } from 'react'
import { createPortal } from 'react-dom'
import styles from './Modal.module.scss'

export default function Modal({
  children,
  wrapperId = 'crystal-eyes-modal',
  parentClassName = '',
  className = '',
  close,
}: {
  children: React.ReactNode
  wrapperId?: string
  parentClassName?: string
  className?: string
  close: () => void
}) {
  const [wrapperElement, setWrapperElement] = useState<HTMLElement | null>(null)

  useLayoutEffect(() => {
    let element = document.getElementById(wrapperId)
    // if element is not found with wrapperId or wrapperId is not provided,
    // create and append to body
    if (!element) {
      element = createWrapperAndAppendToBody(wrapperId)
    }
    setWrapperElement(element)
  }, [wrapperId])

  // wrapperElement state will be null on the very first render.
  if (wrapperElement === null) return null

  return createPortal(
    <ModalWrapper
      parentClassName={parentClassName}
      className={className}
      close={close}
    >
      {children}
    </ModalWrapper>,
    wrapperElement,
  )
}

function ModalWrapper({
  children,
  className,
  parentClassName,
  close,
}: {
  children: React.ReactNode
  className: string
  parentClassName: string
  close: () => void
}) {
  return (
    <div className={`${styles.modal} ${parentClassName}`} onClick={close}>
      <div
        className={`modal-content ${className}`}
        onClick={evt => {
          evt.stopPropagation()
        }}
      >
        {children}
      </div>
    </div>
  )
}

function createWrapperAndAppendToBody(wrapperId: string) {
  const wrapperElement = document.createElement('div')
  wrapperElement.setAttribute('id', wrapperId)
  document.body.appendChild(wrapperElement)
  return wrapperElement
}
